import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

// Session overrides applied on top of the backend hidden state so hide/unhide
// reflect instantly across every view (classId -> hidden: true / shown: false).
export interface HiddenClassesState {
  overrides: Record<string, boolean>;
  justHiddenName: string | null;
}

const initialState: HiddenClassesState = { overrides: {}, justHiddenName: null };

// Stable reference for the fallback so selectors don't return a fresh object each
// call (a new ref would retrigger memos/effects downstream and loop renders).
const EMPTY_OVERRIDES: Record<string, boolean> = {};

export const hiddenClassesSlice = createSlice({
  name: 'hiddenClasses',
  initialState,
  reducers: {
    setClassHidden: (state: HiddenClassesState, action: PayloadAction<{ classId: string; hidden: boolean }>) => {
      state.overrides[action.payload.classId] = action.payload.hidden;
    },
    noteClassHidden: (state: HiddenClassesState, action: PayloadAction<string>) => {
      state.justHiddenName = action.payload;
    },
    clearJustHiddenClass: (state: HiddenClassesState) => {
      state.justHiddenName = null;
    },
  },
});

export const selectHiddenClassOverrides = (state: RootState) => state.hiddenClasses?.overrides ?? EMPTY_OVERRIDES;

export const selectJustHiddenClassName = (state: RootState) => state.hiddenClasses?.justHiddenName ?? null;
export const { setClassHidden, noteClassHidden, clearJustHiddenClass } = hiddenClassesSlice.actions;

export default hiddenClassesSlice.reducer;
